import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Checkbox, Space, Divider } from 'antd';
import { UserOutlined, LockOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { config } from '../config';
import EnvironmentInfo from '../components/EnvironmentInfo';

interface LoginForm {
  username: string;
  password: string;
  remember: boolean;
}

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const handleLogin = async (values: LoginForm) => {
    setLoading(true);
    try {
      // 使用新的认证服务进行登录
      await login(values.username, values.password, values.remember);
      
      // 登录成功后的处理
      // message.success('登录成功！');
      
      // 如果有重定向路径，则跳转到该路径，否则跳转到仪表盘
      const from = location.state?.from?.pathname || '/dashboard';
      navigate(from, { replace: true });
    } catch (error) {
      // 错误处理已在认证服务中完成，这里不需要额外处理
      console.error('Login failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDemoLogin = () => {
    form.setFieldsValue({
      username: 'admin',
      password: 'admin123',
      remember: true,
    });
  };

  const handleClearStorage = () => {
    localStorage.clear();
    message.success('已清除所有本地数据，请重新登录');
    window.location.reload();
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <Card
        style={{
          width: '100%',
          maxWidth: '400px',
          borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
        }}
        bodyStyle={{ padding: '40px 32px' }}
      >
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <h1 style={{ 
            fontSize: '28px', 
            fontWeight: 'bold', 
            color: '#1890ff',
            marginBottom: '8px'
          }}>
            {config.appName}
          </h1>
          <p style={{ color: '#666', fontSize: '14px', marginBottom: '8px' }}>
            请登录您的账户
          </p>
          {/* <div style={{ display: 'flex', justifyContent: 'center' }}>
            <EnvironmentInfo showVersion={true} showDetails={true} />
          </div> */}
        </div>

        <Form
          form={form}
          name="login"
          onFinish={handleLogin}
          initialValues={{ remember: true }}
          size="large"
        >
          <Form.Item
            name="username"
            rules={[
              { required: true, message: '请输入用户名！' },
              { min: 3, message: '用户名至少3个字符！' }
            ]}
          >
            <Input
              prefix={<UserOutlined style={{ color: '#bfbfbf' }} />}
              placeholder="用户名"
              autoComplete="username"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: '请输入密码！' },
              { min: 6, message: '密码至少6个字符！' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: '#bfbfbf' }} />}
              placeholder="密码"
              autoComplete="current-password"
              iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            />
          </Form.Item>

          {/*<Form.Item>*/}
          {/*  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>*/}
          {/*    <Form.Item name="remember" valuePropName="checked" noStyle>*/}
          {/*      <Checkbox>记住我</Checkbox>*/}
          {/*    </Form.Item>*/}
          {/*    <Button type="link" style={{ color: '#1890ff', padding: 0 }}>忘记密码？</Button>*/}
          {/*  </div>*/}
          {/*</Form.Item>*/}

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              style={{
                width: '100%',
                height: '44px',
                borderRadius: '6px',
                fontSize: '16px',
                fontWeight: '500'
              }}
            >
              {loading ? '登录中...' : '登录'}
            </Button>
          </Form.Item>
        </Form>

        {/* <Divider style={{ margin: '24px 0' }}>
          <span style={{ color: '#999', fontSize: '12px' }}>或</span>
        </Divider> */}

        {/* <Space direction="vertical" style={{ width: '100%' }}>
          <Button
            type="default"
            onClick={handleDemoLogin}
            style={{
              width: '100%',
              height: '40px',
              borderRadius: '6px'
            }}
          >
            使用演示账户
          </Button>
          
          <Button
            type="text"
            size="small"
            onClick={handleClearStorage}
            style={{
              width: '100%',
              color: '#999',
              fontSize: '12px'
            }}
          >
            清除本地数据（如果遇到问题）
          </Button>
          
          <div style={{ textAlign: 'center', fontSize: '12px', color: '#999' }}>
            演示账户：admin / admin123
          </div>
        </Space> */}

        {/* <div style={{ 
          marginTop: '24px', 
          padding: '16px', 
          background: '#f6f8fa', 
          borderRadius: '6px',
          fontSize: '12px',
          color: '#666'
        }}>
          <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>功能说明：</div>
          <div>• 支持用户名密码登录</div>
          <div>• 记住登录状态</div>
          <div>• 路由权限控制</div>
          <div>• 响应式设计</div>
          <div>• JWT令牌认证</div>
          <div>• 自动令牌刷新</div>
        </div> */}
      </Card>
    </div>
  );
};

export default Login; 